"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.columns = exports.INITIAL_VISIBLE_COLUMNS = exports.validationConfig = exports.statusOptions = void 0;
exports.statusOptions = [
    { label: "Draft", value: "draft" },
    { label: "Published", value: "published" },
    { label: "Archived", value: "archived" },
];
exports.validationConfig = {
    question: { required: true, minLength: 5 },
    answer: { required: true, minLength: 5 },
    category: { required: true },
    sort_order: { required: true },
    status: { required: true },
};
exports.INITIAL_VISIBLE_COLUMNS = ["question", "category", "sort_order", "status", "actions"];
exports.columns = [
    { name: "Question", uid: "question", sortable: true },
    { name: "Category", uid: "category", sortable: true },
    { name: "Sort Order", uid: "sort_order", sortable: true },
    { name: "Status", uid: "status", sortable: true },
    { name: "Actions", uid: "actions", sortable: false },
];
